<template>
  <div class="text-input-container">
    <FormLabel :label="label" :isRequired="isRequired && !readOnly" />
    <div class="text-input-wrapper">
      <!-- readonlyモードではテキスト表示 -->
      <div v-if="readOnly" class="readonly-text">
        {{ displayValue }}
      </div>
      <!-- 通常モードではテキストボックス -->
      <input
        v-else
        :value="value"
        :placeholder="placeholder"
        :type="type"
        :disabled="disabled"
        :class="['text-input', { error: errorMessage }]"
        @input="onInput"
        @blur="onBlur"
      />
      <span v-if="unit && !readOnly" class="unit-text">{{ unit }}</span>
    </div>
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    <InputBottomDivider v-if="readOnly" />
  </div>
</template>

<script>
import FormLabel from "./FormLabel.vue";
import InputBottomDivider from "./InputBottomDivider.vue";
export default {
  name: "TextInput",
  components: {
    FormLabel,
    InputBottomDivider,
  },
  props: {
    /**
     * ラベルテキスト
     * @type {String}
     * @required
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * 入力値
     * @type {String|Number}
     * @default ""
     */
    value: {
      type: [String, Number],
      default: "",
    },
    /**
     * プレースホルダー
     * @type {String}
     * @default ""
     */
    placeholder: {
      type: String,
      default: "",
    },
    /**
     * 必須項目かどうか
     * @type {Boolean}
     * @default false
     */
    isRequired: {
      type: Boolean,
      default: false,
    },
    /**
     * 読み取り専用かどうか
     * @type {Boolean}
     * @default false
     */
    readOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * 無効化されているかどうか
     * @type {Boolean}
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 入力タイプ
     * @type {String}
     * @default "text"
     */
    type: {
      type: String,
      default: "text",
    },
    /**
     * 単位テキスト
     * @type {String}
     * @default ""
     */
    unit: {
      type: String,
      default: "",
    },
    /**
     * エラーメッセージ
     * @type {String}
     * @default ""
     */
    errorMessage: {
      type: String,
      default: "",
    },
  },
  computed: {
    displayValue() {
      if (
        this.value === null ||
        this.value === undefined ||
        this.value === ""
      ) {
        return "-";
      }
      return `${this.value} ${this.unit}`;
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
    onBlur(e) {
      this.$emit("blur", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.text-input-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .text-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .readonly-text {
      padding: 0rem 0.75rem;
      font-family: $aisea-font-family;
      font-size: 16px;
      font-weight: 400;
      color: $aisea-dark-gray;
      line-height: 1.5;
      min-height: 26px;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    .text-input {
      flex: 1;
      min-width: 100px;
      padding: 0.6rem 0.75rem;
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 400;
      color: $aisea-dark-gray;
      background-color: $aisea-pure-white;
      border: 1px solid $aisea-mouse-gray;
      border-radius: 6px;
      outline: none;
      transition: border-color 0.3s ease, box-shadow 0.3s ease;

      &::placeholder {
        color: $aisea-mouse-gray;
      }

      &:focus {
        border-color: $aisea-blue;
        box-shadow: 0 0 0 2px rgba(45, 156, 219, 0.1);
      }

      &:disabled {
        background-color: $aisea-light-gray;
        color: $aisea-mouse-gray;
        cursor: not-allowed;
      }

      &.error {
        border-color: $aisea-red;
        background-color: rgba($aisea-red, 0.1);
      }
    }

    .unit-text {
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 400;
      color: $aisea-dark-gray;
      white-space: nowrap;
    }
  }
  .error-message {
    margin-top: 0.25rem;
    padding-left: 0.25rem;
    font-family: $aisea-font-family;
    font-size: 12px;
    font-weight: 400;
    color: $aisea-red;
    line-height: 1.5;
  }
}
</style>
